import React, { useEffect, useState, useContext }  from 'react';
import './CasinoBanners.css';
import { useSelector } from 'react-redux';
import { BannerLoader } from '../../../../../shared/src/components/BannersCarousel/BannerLoader';
import ReactDOM from 'react-dom';
import { useCollapseBanner } from '../hooks/collapse-banner.hook';
import { BannersCarousel } from '../../../../../shared/src/components/BannersCarousel/BannersCarousel';
import { AsgAppContext, AsgDictionaryContext, AsgFwContext } from '../../../contexts';
import { useLoginStateBannerLoaders } from './login-state-banner-loaders.hook';
import { usePreloadFirstBanner } from './preload-first-banner.hook';
import { verticalTypesEnum } from '../../../../../shared/src/enums/vertical-types.enum';

export const CasinoBanners = ({
    verticalType,
}) => {
    const [portal, setPortal] = useState(null);
    const [bannersCollapseTimerExpired, setBannersCollapseTimerExpired] = useState(false);
    const [bannersCollapseTimer, setBannersCollapseTimer] = useState(0);
    const [loginStateChangeInProgress, setLoginStateChangeInProgress] = useState(false);
    const [firstImgPreloaded, setFirstImgPreloaded] = useState(false);

    const Dictionary = useContext(AsgDictionaryContext);
    const AsgFW = useContext(AsgFwContext);
    const AsgApp = useContext(AsgAppContext);

    const {
        isNeoCmsIntegrationEnabled,
    } = useSelector((state) => state.app);

    const isLiveCasino = verticalType === verticalTypesEnum.LIVE_CASINO;
    const bannersKey = isNeoCmsIntegrationEnabled && isLiveCasino
        ? 'liveCasinoBanners'
        : 'casinoBanners';

    const {
        [bannersKey]: {
            placeholderBannerData,
            bannersList,
        }
    } = useSelector((state) => state.app);

    // get and save target element for portal
    useEffect(() => {
        const portalElement = document.getElementById('asg-vertical-banners-portal');

        if (portalElement) {
            setPortal(portalElement);
        }
    }, []);

    useCollapseBanner(
        portal,
        bannersList,
        setBannersCollapseTimer,
        setBannersCollapseTimerExpired,
        bannersCollapseTimer,
    );

    useLoginStateBannerLoaders(
        setLoginStateChangeInProgress,
        bannersList,
    );

    usePreloadFirstBanner(
        setFirstImgPreloaded,
        bannersList,
    );

    if (!portal) {
        return null;
    }

    const animatedLoaderEnabled = !placeholderBannerData.active;
    const placeholderLoaderEnabled = placeholderBannerData.active;

    const showAnimatedLoader = (
        // show loader if no banners yet available, AE is ON and no placeholder
        (!bannersList && !placeholderBannerData.active)
        // or login in progress
        || (loginStateChangeInProgress && animatedLoaderEnabled)
        // or img preloading in progress
        || (!firstImgPreloaded && animatedLoaderEnabled)
    );

    const showPlaceholderImg = (
        // show placeholder if no banners yet available, AE is ON and placeholder configured
        (!bannersList && placeholderBannerData.active)
        // or login in progress and placeholder configured and AE is ON
        || loginStateChangeInProgress && placeholderLoaderEnabled
        // or img preloading in progress
        || !firstImgPreloaded && placeholderLoaderEnabled
    );

    const showCarousel = bannersList
        && firstImgPreloaded
        && !loginStateChangeInProgress;

    const wrapperClasses = [
        'banners-wrapper',
        'banners-visible',
        bannersCollapseTimerExpired ? 'collapse-transition' : '',
        'aspire-engage',
    ];

    const carouselClasses = [
        'transition-opacity-out',
        'banners-visible',
        'aspire-engage',
        showPlaceholderImg ? 'banners-carousel--placeholder-visible' : '',
    ];

    return ReactDOM.createPortal((
        <section className={wrapperClasses.join(' ')}>
            {showAnimatedLoader && <BannerLoader />}

            {showPlaceholderImg && <div id="banners-carousel" className={carouselClasses.join(' ')}>
                <img
                    src={placeholderBannerData.url}
                    className="banners-wrapper__placeholder-img"
                    alt="Banner loading img"
                />
                <div className="carousel-content">
                    <div className="carousel-content__headlines">
                        <div className="carousel-content__title">{placeholderBannerData.title}</div>
                        <div className="carousel-content__subtitle">{placeholderBannerData.subTitle}</div>
                    </div>
                </div>
            </div>}

            {showCarousel && <div id="banners-carousel" className={carouselClasses.join(' ')}>
                <BannersCarousel
                    bannersData={bannersList}
                    globals={{
                        Dictionary,
                        AsgFW,
                        AsgApp,
                    }}
                />
            </div>}
        </section>
    ), portal);
};
